// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ErrorPaymentOverlay_overlay__30c0k","overlay__title":"ErrorPaymentOverlay_overlay__title__3v7GB","overlay__subtitle":"ErrorPaymentOverlay_overlay__subtitle__ke3XI"};